import { FontSizeToken, TFontSize } from './fontSize'
import { FontWeightToken, TFontWeight } from './fontWeight'
import { FontHeight, TLineHeight } from './lineHeight'

export default {
  fontSize: FontSizeToken,
  fontWeight: FontWeightToken,
  fontHeight: FontHeight,
}

export type TTypography = TFontSize | TFontWeight | TLineHeight
